import React from 'react';
import { WhiteArrow, BlackArrow } from './arrows';

const useArrowPosition = (circleDimensions, indicator) => { 

  const { center, radius } = circleDimensions;

  const percent = Math.max(0, Math.min(100, Number(indicator.value)));

  const angleStart = -Math.PI / 2;
  const angleEnd = angleStart + (2 * Math.PI * percent) / 100;

  const x = center + radius * Math.cos(angleEnd);
  const y = center + radius * Math.sin(angleEnd);

  const aspect = 34 / 24;
  const height = indicator.size;
  const width = indicator.size / aspect;
  const positionTransform = `translate(${x - width / 2},${y - height}) rotate(${(percent/100)*360}, ${width / 2}, ${height})`;

  return { height, width, positionTransform };
}

export const useMaxIndicatorSizeValue = (whiteIndicator, blackIndicator) => { 
  if (whiteIndicator && blackIndicator)
    return Math.max(whiteIndicator.size, blackIndicator.size);
  if (whiteIndicator)
    return whiteIndicator.size;
  if (blackIndicator)
    return blackIndicator.size;
  return 0;
}

export const BlackIndicator = ({ dotColor, color, dimensions, indicator }) => {
  const position = useArrowPosition(dimensions, indicator);
  return <BlackArrow {...position} dotColor={dotColor} color={ color }  /> ;
};

export const WhiteIndicator = ({ color, dimensions, indicator }) => {
  const position = useArrowPosition(dimensions, indicator);
  return <WhiteArrow {...position} color={color} />;
};